import React, { createContext, useContext, useState, useCallback } from 'react';
import io from 'socket.io-client';

const AuctionContext = createContext();
const socket = io('http://localhost:5000');

export const AuctionProvider = ({ children }) => {
  const [activeAuctions, setActiveAuctions] = useState(new Map());
  const [notifications, setNotifications] = useState([]);

  const addNotification = useCallback((message, type = 'info') => {
    const id = Date.now();
    setNotifications(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id));
    }, 5000);
  }, []);

  const updateAuction = useCallback((auctionId, data) => {
    setActiveAuctions(prev => new Map(prev).set(auctionId, data));
  }, []);

  React.useEffect(() => {
    socket.on('auctionUpdated', (auction) => {
      updateAuction(auction._id, auction);
      addNotification(`Aukce byla aktualizována: ${auction.currentBid.toLocaleString()} Kč`);
    });

    socket.on('auctionStarted', (auction) => {
      updateAuction(auction._id, auction);
      addNotification('Aukce začala!', 'success');
    });

    socket.on('auctionCompleted', (result) => {
      updateAuction(result.auctionId, prev => ({
        ...prev,
        status: 'completed',
        winner: result.winner,
        finalPrice: result.finalPrice
      }));
      addNotification(`Aukce skončila! Vítězná nabídka: ${result.finalPrice.toLocaleString()} Kč`, 'success');
    });

    return () => {
      socket.off('auctionUpdated');
      socket.off('auctionStarted');
      socket.off('auctionCompleted');
    };
  }, [updateAuction, addNotification]);

  const value = {
    activeAuctions,
    notifications,
    updateAuction,
    addNotification,
    socket
  };

  return (
    <AuctionContext.Provider value={value}>
      {children}
    </AuctionContext.Provider>
  );
};

export const useAuctionContext = () => {
  const context = useContext(AuctionContext);
  if (!context) {
    throw new Error('useAuctionContext must be used within an AuctionProvider');
  }
  return context;
}; 